import { LogLevel } from '@azure/msal-browser'

/**
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

export const b2cPolicies = {
  names: {
    signUpSignIn: import.meta.env.VITE_AUTH_POLICY_SIGNIN,
    // forgotPassword: "<Forgot Password Name - in the form of B2C_1_xxx>",
    // editProfile: "<Edit Profile Name - in the form of B2C_1_xxx>",
    // signin: "B2C_1_signin_username",
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${import.meta.env.VITE_AUTH_SUBDOMAIN}.b2clogin.com/${import.meta.env.VITE_AUTH_SUBDOMAIN}.onmicrosoft.com/${import.meta.env.VITE_AUTH_POLICY_SIGNIN}`,
    },
    forgotPassword: {
      authority: `https://${import.meta.env.VITE_AUTH_SUBDOMAIN}.b2clogin.com/${import.meta.env.VITE_AUTH_SUBDOMAIN}.onmicrosoft.com/<Forgot Password Name - in the form of B2C_1_xxx>`,
    },
    editProfile: {
      authority: `https://${import.meta.env.VITE_AUTH_SUBDOMAIN}.b2clogin.com/${import.meta.env.VITE_AUTH_SUBDOMAIN}.onmicrosoft.com/<Edit Profile Name - in the form of B2C_1_xxx>`,
    },
  },
  authorityDomain: `${import.meta.env.VITE_AUTH_SUBDOMAIN}.b2clogin.com`,
}

/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const redirectUri = sessionStorage.getItem('redirectPath') || '/'

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    validateAuthority: false,
    redirectUri,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
  },
  scopes: [
    'openid',
    'offline_access',
    `https://${import.meta.env.VITE_AUTH_SUBDOMAIN}.onmicrosoft.com/${import.meta.env.VITE_AUTH_MSAL_CLIENT_ID}/demo.read`,
  ],
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            // console.info(message)
            return
          case LogLevel.Verbose:
            // console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
          // return;
        }
      },
    },
  },
}

/**
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [
    `https://${import.meta.env.VITE_AUTH_SUBDOMAIN}.onmicrosoft.com/${import.meta.env.VITE_AUTH_MSAL_CLIENT_ID}/demo.read`,
  ],
}
